/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembershipDto } from '../../models/membership-dto';

export interface GetMembership$Params {
  id: string;
}

export function getMembership(http: HttpClient, rootUrl: string, params: GetMembership$Params, context?: HttpContext): Observable<StrictHttpResponse<MembershipDto>> {
  const rb = new RequestBuilder(rootUrl, getMembership.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembershipDto>;
    })
  );
}

getMembership.PATH = '/v0/memberships/{id}';
